import React, { useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap'
import { useState } from 'react';
import travelImage from "../../assets/images/scanMe/main_travel_image.png"
import { Button, Grid, Typography } from '@mui/material';
import moment from 'moment';

const TravelCareMembership = ({ travellerData }) => {

    const [travellerName, setTravellerName] = useState('')
    const [travelAgencyName, setTravelAgencyName] = useState('')
    const [travelCareMembership, setTravelCareMembership] = useState(null)
    const [planAvailed, setPlanAvailed] = useState(null)
    const [coverage, setCoverage] = useState(null)
    const [travelStartDate, setTravelStartDate] = useState(null)
    const [travelEndDate, setTravelEndDate] = useState(null)
    const [companyLogoPath, setCompanyLogoPath] = useState(null)

    useEffect(() => {
        
        const data = travellerData[0]?.travellers[0] || {};

        if (travellerData[0]?.travel_start_date) {
            const startDate = moment(travellerData[0].travel_start_date);
            const newTravelStartDate = {
                day: startDate?.format('D'),
                // month: startDate?.format('MMM').toUpperCase(),
                month: startDate?.format('MMM'),
                year: startDate?.format('YY'),
                ordinal: startDate?.format('Do').replace(startDate.format('D'), '').toLowerCase()
            }
            // newTravelStartDate.month = newTravelStartDate.month.format
            setTravelStartDate(newTravelStartDate);
            console.log(">>>>>>>>>>>>>>>", newTravelStartDate)
        }
        if (travellerData[0]?.travel_end_date) {
            const endDate = moment(travellerData[0].travel_end_date);
            const newTravelEndDate = {
                day: endDate?.format('D'),
                // month: endDate?.format('MMM').toUpperCase(),
                month: endDate?.format('MMM'),
                year: endDate?.format("YY"),
                ordinal: endDate?.format('Do').replace(endDate.format('D'), '').toLowerCase()
            }
            setTravelEndDate(newTravelEndDate);
            console.log(">>>>>>>>>>>>", newTravelEndDate)
        }



        // const start_date = convertDate(travellerData[0]?.travel_start_date) || "NA";
        // const end_date = convertDate(travellerData[0]?.travel_end_date) || "NA";
        const path = data?.plan?.Company?.client_company_logo || "NA"
        setCompanyLogoPath(path)

        setTravellerName(data?.firstName || "NA");
        // setTravelAgencyName(travellerData[0]?.partnership?.name || "NA");
        setTravelAgencyName(travellerData[0]?.partnership?.name
            ?.split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ') || "NA");
        setTravelCareMembership(travellerData[0]?.document_unique_code || "NA");

        setPlanAvailed(data.plan?.title || "NA");

        // setTravelStartDate(start_date);
        // setTravelEndDate(end_date);
        const formatNumber = (number) => {
            return new Intl.NumberFormat('en-US').format(number);
          };
          
          // Example usage
          const memberCoverage = data?.member_coverage ? formatNumber(data.member_coverage) : "NA";
        setCoverage(`${data?.plan?.currency?.symbol} ${memberCoverage}` || "NA");

    }, [travellerData])

    return (
        <>
            <Container fluid={true} className="mt-5 " sx={{ fontFamily: 'Poppins, sans-serif' }}>
                <Grid container justifyContent="center" spacing={4}>
                    <Grid item xs={12} sm={6} className='d-flex align-items-center'>
                        <div>
                            <div style={{ display: 'flex' }}>
                                <Typography variant="h5" style={{ marginLeft: '-3px' }}>
                                    Europ Assistance
                                </Typography>
                            </div>
                            <div style={{ marginTop: '20px' }}>
                                <Typography variant="body1" style={{ margin: '0' }}>
                                    hello,
                                </Typography>
                                <Typography style={{ fontWeight: '800', fontSize: '28px', marginTop: '-18px', lineHeight: '54px', letterSpacing: '0%' }}>
                                    {travellerName}!
                                </Typography>
                            </div>
                            <div style={{ marginTop: '20px' }}>
                                <Typography variant="body2" style={{ fontSize: '14px' }}>
                                    Thank you for choosing <span style={{ color: '#00239b', fontWeight: 'bold' }}>Europ Assistance</span> via <span style={{ color: '#00239b', fontWeight: 'bold' }}>{travelAgencyName}</span> with your Travel Care Plan! Sit back & enjoy, we'll take good care of you.
                                </Typography>
                                <Typography variant="body2" style={{ fontSize: '14px' }}>
                                    These are the details we have of you & your upcoming travels. Help us with some more details to avail your benefits!
                                </Typography>
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6} className='d-flex align-items-center justify-content-center position-relative'>
                        <img
                            src={travelImage}
                            alt='name of img'
                            style={{ maxWidth: '100%', height: 'auto', borderRadius: '0px 40px 0px 40px' }}
                        />
                        {/* <Button
                                variant="outlined" // This is a good starting point for a button with a border
                                sx={{
                                    position: 'absolute',
                                    bottom: '24%', // Adjust as needed
                                    left: '53%',
                                    transform: 'translateX(-50%)', // Horizontally centers the button
                                    backgroundColor: 'transparent',
                                    borderRadius: '20px',      // User specified, adjust if you want more oval
                                    color: 'white',            // Text color
                                    textTransform: 'none',
                                    borderColor: 'white',      // Sets the border color to black
                                    borderWidth: '1.5px',      // Adjust thickness as needed
                                    padding: '2px 6px',       // Adjust padding for desired size
                                    fontSize: '1rem',          // Adjust font size
                                    fontWeight: 500,
                                    zIndex: 1,
                                    '&:hover': {
                                        backgroundColor: 'rgba(0, 0, 0, 0.1)', // Slight dark overlay on hover
                                        borderColor: 'black', // Keep border color black on hover
                                        color: 'white',       // Keep text color white on hover
                                    },
                                    position:'absolute'
                                    // ml: 3 is removed as it's not suitable for absolute centered positioning
                                }}
                        > Discover</Button> */}
                    </Grid>
                </Grid>
                <Grid container justifyContent="center" spacing={4} className="mt-0">
                    <Grid item xs={12} sm={6} md={3} className='d-flex flex-column align-items-center justify-content-center' style={{ marginBottom: '0px' }}>
                        <div style={{ textAlign: 'center' }}>
                            <Typography variant="body2" style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                Travel Care Membership #
                            </Typography>
                        </div>
                        <Button color="primary" className="stepper-next-btn" style={{ width: '250px', height: '50px', marginTop: '10px' }}>
                            {travelCareMembership}
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} className='d-flex flex-column align-items-center justify-content-center' style={{ marginBottom: '0px' }}>
                        <div style={{ textAlign: 'center' }}>
                            <Typography variant="body2" style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                Plan availed for the journey
                            </Typography>
                        </div>
                        <Button color="primary" className="stepper-next-btn" style={{ width: '250px', height: '50px', marginTop: '10px', textTransform: 'none' }}>
                            {planAvailed}
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} className='d-flex flex-column align-items-center justify-content-center' style={{ marginBottom: '0px' }}>
                        <div style={{ textAlign: 'center' }}>
                            <Typography variant="body2" style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                Travel Dates
                            </Typography>
                        </div>
                        
                        <Button color="primary" className="stepper-next-btn" style={{ width: '250px', height: '50px', marginTop: '10px',textTransform: 'none' }}>
                            {travelStartDate?.day}<sup style={{textTransform: 'lowercase'}}>{travelStartDate?.ordinal.toLowerCase()}</sup> <p>{` `}</p>{travelStartDate?.month} {travelStartDate?.year} - {travelEndDate?.day}<sup style={{textTransform: 'lowercase'}}>{travelEndDate?.ordinal.toLowerCase()}</sup> {` `} {travelEndDate?.month} {travelEndDate?.year}
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} className='d-flex flex-column align-items-center justify-content-center' style={{ marginBottom: '0px' }}>
                        <div style={{ textAlign: 'center' }}>
                            <Typography variant="body2" style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                Coverage
                            </Typography>
                        </div>
                        <Button color="primary" className="stepper-next-btn" style={{ width: '250px', height: '50px', marginTop: '10px' }}>
                            {coverage}
                        </Button>

                    </Grid>
                </Grid>
                <Grid container justifyContent="end" className="mt-0" style={{width: '100%', height: '100px'}}>
                    <Grid item xs={12} sm={6} md={3} className='d-flex flex-column align-items-center justify-content-center'>
                        {/* <img src={companyLogoPath} alt="" style={{ width: '90px', height: 'auto', marginTop: '-20px', marginLeft: '30px' }} /> */}
                    </Grid>
                </Grid>
            </Container>
        </>
    );
}

export default TravelCareMembership;


